import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import { isEmpty } from 'lodash';

import Layers from '../../../api/Layers/Layers';

import NotFound from '../NotFound';

import ThematicLayerContainer from '../../containers/ThematicLayerContainer';

import Loading from '../../components/Loading';

const PublicThematicTable = ({ loading, layer, isAtlas }) => {
  if (loading) return <Loading />;
  if (isEmpty(layer)) return <NotFound />;
  return (
    <Row className={isAtlas ? 'h-100 w-100 p-0 m-0' : ''}>
      <Col xs={12} className={isAtlas ? 'h-100 w-100 p-0' : 'px-3'}>
        <ThematicLayerContainer layer={layer} isShared isAtlas={isAtlas} />
      </Col>
    </Row>
  );
};

PublicThematicTable.defaultProps = {
  loading: true,
  layer: {},
  isAtlas: false
};

PublicThematicTable.propTypes = {
  loading: PropTypes.bool,
  layer: PropTypes.object,
  isAtlas: PropTypes.bool
};

export default withTracker(({ match, privateShared }) => {
  if (privateShared) {
    const publicLayerDataId = match.params.public_layer_data_id;
    const layerSub = Meteor.isClient && Meteor.subscribe('layers.privateData', publicLayerDataId);
    return {
      loading: !Meteor.isClient || !layerSub.ready(),
      layer: Layers.findOne({ publicDataId: publicLayerDataId })
    };
  }
  const publicLayerDataId = match.params.public_layer_data_id;
  const layerSub = Meteor.isClient && Meteor.subscribe('layers.publicData', publicLayerDataId);
  return {
    loading: !Meteor.isClient || !layerSub.ready(),
    layer: Layers.findOne({ publicDataId: publicLayerDataId })
  };
})(PublicThematicTable);
